// extracted by mini-css-extract-plugin
export default {"radio-wrap":"RadioBtnForm_radio-wrap__HP5ge","radio-btn":"RadioBtnForm_radio-btn__HDQlH","radio-label":"RadioBtnForm_radio-label__MVvRB"};